/**
 * The grading reports' units (client 2026-10-20): the organization's grading
 * apps, each graded by its own coach, in the dashboard's order (offense, then
 * defense). `apiKey` is the app's bucket on the server (the `x-app-selected`
 * header).
 */
export interface GradingUnit {
  /** The app's key ("lb"). */
  key: string;
  apiKey: string;
  title: string;
}

export const GRADING_UNITS: readonly GradingUnit[] = [
  { key: "rb", apiKey: "RunningBack", title: "Running Backs" },
  { key: "te", apiKey: "TightEnd", title: "Tight Ends" },
  { key: "wr", apiKey: "WideReceiver", title: "Wide Receivers" },
  { key: "lb", apiKey: "LineBacker", title: "Linebackers" },
  { key: "s", apiKey: "Safety", title: "Safeties" },
  { key: "dl", apiKey: "DL", title: "Defensive Line" },
  { key: "db", apiKey: "DefensiveBack", title: "Defensive Backs" },
  { key: "dc", apiKey: "DefensiveCoordinator", title: "Defensive Coordinator" },
];

/** The Defensive Coordinator's app: the one that sees every unit. */
export const COORDINATOR = "dc";

const OWN = new Map(GRADING_UNITS.map((unit) => [unit.key, [unit] as const]));
const NONE: readonly GradingUnit[] = [];

/**
 * The units an app's reports show (client 2026-10-23): a position app's are
 * its own; the Defensive Coordinator's, every unit (its own grades one of
 * them). The same list each time, so it can be a hook's dependency.
 */
export const unitsFor = (appKey: string): readonly GradingUnit[] =>
  appKey === COORDINATOR ? GRADING_UNITS : (OWN.get(appKey) ?? NONE);

export const unitTitle = (key: string): string => GRADING_UNITS.find((u) => u.key === key)?.title ?? key.toUpperCase();

/** "Tight Ends", "Tight Ends and Safeties", "A, B and C". */
export const unitList = (keys: readonly string[]): string => {
  const names = keys.map(unitTitle);
  return names.length <= 1 ? (names[0] ?? "") : `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};
